import { render, staticRenderFns } from "./IndividualGuardians.vue?vue&type=template&id=43a8e4fa"
import script from "./IndividualGuardians.vue?vue&type=script&lang=js"
export * from "./IndividualGuardians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports